import React, { useState, useEffect } from "react";
import "./editmsr.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { useDispatch } from "react-redux";
import { notify } from '../../services/notification';
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { MsrNameAction, UpdateMsrAction } from "../../actions/msrAction";
import { useParams, useNavigate } from "react-router-dom";
import { decode } from "base-64";
import { HiMenu, HiX } from "react-icons/hi";
import { MOBILE_BREAKPOINT, HTTP_STATUS } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";


function EditMsr() {
  const [loading, setLoading] = useState(false);
  const { isSidebarOpen, toggleSidebar } = useMobileView();


  const [state, setstate] = useState({
    name: "",
    msr_id: "",
    mobile_number: "",
    address: "",
  });
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      getMsrdata(id);
    }
  }, [id]);


  const getMsrdata = async (id) => {
    setLoading(true);
    try {
      const response = await dispatch(MsrNameAction(decode(id)));
      if (response?.status === 200) {
        setLoading(false);
        const state = response?.data;
        setstate(state?.data);
      } else if (response === undefined) {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setstate({
      ...state,
      [name]: value,
    });
  };

  const handleOnUpdateClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (state.mobile_number === "") {
      delete state.mobile_number;
    }

    try {
      const response = await dispatch(UpdateMsrAction(state, decode(id)));
      if (response?.status === 200) {
        setLoading(false);
        notify.success(response?.data?.message);
        navigate("/msr");
      } else if (response?.status === 400) {
        setLoading(false);
        notify.error(response?.data?.message);
      } else {
        setLoading(false);
        notify.error(response.data?.message);
      }
    } catch (error) {
      setLoading(false);
      notify.error(error?.data?.message);
    }
  };

  return (
    <div className="edit-msr-container">
      <div className="edit-msr-containerright">
        <Header title="Edit MSR" />
        <div className="edit-msr">
          {loading ? (
            <Loader />
          ) : (
            <form onSubmit={handleOnUpdateClick} className="form-div">
              <div className="grid date">
                <label className="label-edit-msr">Name</label>
                <input
                  type="text"
                  name="name"
                  value={state?.name}
                  onChange={handleInputChange}
                  className="edit-msr-input-field"
                  required
                />
              </div>
              <div className="grid">
                <label className="label-edit-msr">MSR ID</label>
                <input
                  type="text"
                  name="msr_id"
                  value={state?.msr_id}
                  onChange={handleInputChange}
                  required
                  className="edit-msr-input-field"
                  readOnly
                />
              </div>
              <div className="grid">
                <label className="label-edit-msr">
                  Phone Number
                </label>
                <input
                  type="text"
                  name="mobile_number"
                  value={state?.mobile_number}
                  onChange={handleInputChange}
                  minLength={10}
                  maxLength={10}
                  readOnly
                  className="edit-msr-input-field"
                />
              </div>
              <div className="grid">
                <label className="label-edit-msr-address">Address</label>
                <textarea
                  rows={1}
                  cols={1}
                  type="text"
                  name="address"
                  value={state?.address}
                  onChange={handleInputChange}
                  className="edit-msr-input-field"
                />
              </div>

              <div className="btn-notify">
                <button
                  onClick={() => {
                    navigate("/msr");
                  }}
                  className="msr-active"
                >
                  Close
                </button>
                <button className="msr-active" type="submit" disabled={!state.name || !state.msr_id || !state.mobile_number}>
                  Update
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default EditMsr;